import { ModifyIdentity } from '@grid/models';
import { CopyDprSectionOptions } from '..';
export interface CopyDprOptionGridData
  extends ModifyIdentity<CopyDprSectionOptions> {}
